import { render, staticRenderFns } from "./UniDetailCampus.vue?vue&type=template&id=1e2617dc&scoped=true&"
import script from "./UniDetailCampus.vue?vue&type=script&lang=js&"
export * from "./UniDetailCampus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2617dc",
  null
  
)

export default component.exports